
import { Component, Vue } from "vue-property-decorator";
import CitiesTable from "../components/City/CitiesTable.vue";
import { City } from "@/models/City";
import GameTypeTable from "../components/GameTypes/GameTypeTable.vue";
import ViewCity from "../components/City/ViewCity.vue";
import ViewGameTypes from "../components/GameTypes/ViewGameTypes.vue";
import { Season } from "@/models/GameType";

@Component({
  components: {
    CitiesTable,
    GameTypeTable,
    ViewCity,
    ViewGameTypes,
  },
})
class Create extends Vue {
  gameType = false;
  showCityTabs = false;
  showGameTabs = false;
  isSelectable = true;
  seasonData = {} as Season;
  tabIndex = 0;

  get isEditing(): boolean {
    if (this.gameType) {
      return this.$store.state.gameStore.isEditing;
    } else {
      return this.$store.state.cityStore.isEditing;
    }
  }
  created(): void {
    this.$store.commit("authenication/setNavTab", 2);
  }

  handleCitySelection(rows: City): void {
    this.$store.dispatch("cityStore/getSingleCity", rows.slug);
    this.showCityTabs = true;
  }
  handleGameTypeSelection(rows: Season): void {
    this.seasonData = rows;
    this.showGameTabs = true;
  }
  closeTabs(): void {
    this.showCityTabs = false;
  }
  handleCloseSelection(): void {
    this.showGameTabs = false;
  }
  setCities(): void {
    if (!this.isEditing) {
      this.gameType = false;
      this.showCityTabs = false;
      this.tabIndex = 0;
    }
  }
  setGames(): void {
    if (!this.isEditing) {
      this.gameType = true;
      this.showGameTabs = false;
      this.tabIndex = 1;
      this.seasonData = {} as Season;
    }
  }
}

export default Create;
